var _circle, _circle2, _rect, _circle3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationCollab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3164,
    cy: 10,
    r: 9.75,
    fill: "#FFEFE3",
    stroke: "#FF8A3D",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.4164,
    cy: 7.4,
    r: 1.85,
    fill: "#FF8A3D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.3164,
    y: 11.3,
    width: 6.2,
    height: 4,
    rx: 2,
    fill: "#FF8A3D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7164,
    cy: 8.3,
    r: 2.35,
    fill: "#FF8A3D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.8164,
    y: 12.3,
    width: 7.8,
    height: 4,
    rx: 2,
    fill: "#FF8A3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCollab);
export default __webpack_public_path__ + "static/media/notification_collab.984bc5fee6e476977336c4db216c47a7.svg";
export { ForwardRef as ReactComponent };